import React from 'react'
import { ChevronDown, ChevronUp } from 'baseui/icon'
import { styled, useStyletron } from 'baseui'
import { FlexBetween, FlexCenterY } from '@/shared/theme/styled-components'

// eslint-disable-next-line react/prop-types
export const CustomToggleIcon = function ({ $expanded, $style, ...restProps }) {
  const [, theme] = useStyletron()
  const mergedStyle = Object.assign({}, $style, {
    width: '2rem',
    height: '2rem',
    color: theme.colors.mono500,
  })
  return $expanded
    ? React.createElement(ChevronUp, Object.assign({}, restProps, { style: mergedStyle }))
    : React.createElement(ChevronDown, Object.assign({}, restProps, { style: mergedStyle }))
}

export const StyledContainer = styled('div', () => ({
  width: '100%',
  padding: '0rem',
  paddingBottom: '0.4rem',
}))

export const StyledTopContainer = styled('div', () => ({
  width: '100%',
  padding: '1rem',
}))

export const StyledHeader = styled(FlexBetween, {
  marginBottom: '1rem',
})

export const StyledTitle = styled('h3', ({ $theme }) => ({
  marginTop: 0,
  marginBottom: 0,
  marginLeft: 0,
  marginRight: 0,
  fontWeight: '600',
  fontSize: '1.125rem',
  lineHeight: '160%',
  color: $theme.colors.textHeading,
}))

export const StyledIndicator = styled('span', ({ $theme }) => ({
  fontWeight: '600',
  fontSize: '1.125rem',
  lineHeight: '160%',
  color: $theme.colors.textHeading,
}))

export const StyledCurrentValue = styled('span', ({ $theme, $reachedMax }) => ({
  color: $reachedMax ? $theme.colors.textHeading : $theme.colors.mono500,
}))

export const StyledProgressBarContainer = styled('div', () => ({
  position: 'relative',
  width: '100%',
  // necessary to align correctly the bar to the left
  marginLeft: '-0.8rem',
}))

export const StyledCreditIcon = styled('img', () => ({
  position: 'absolute',
  right: '0.10rem',
  top: '50%',
  transform: 'translate(70%, -50%)',
  width: '1.8rem',
}))

export const StyledFooterText = styled('p', () => ({
  fontSize: '1rem',
  lineHeight: '160%',
}))

export const ProgressBarOverrides = {
  BarContainer: {
    style: () => ({
      width: '100%',
    }),
  },
  Bar: {
    style: ({ $theme }) => ({
      position: 'relative',
      width: '100%',
      height: $theme.sizing.scale400,
      borderRadius: '0.5rem',
    }),
  },
  BarProgress: {
    style: ({ $theme }) => ({
      backgroundColor: $theme.colors.positive500,
    }),
  },
}

export const StyledAccordionContainer = styled('div', ({ $theme }) => ({
  borderTop: `0.1rem solid ${$theme.colors.borderSoft}`,
}))

export const PanelOverrides = isLast => ({
  PanelContainer: {
    style: ({ $theme }) => ({
      borderBottom: isLast ? 'none' : `0.1rem solid ${$theme.colors.borderSoft}`,
    }),
  },
  Header: {
    style: ({ $theme }) => ({
      paddingLeft: 0,
      paddingRight: '0.75rem',
      marginBottom: '0rem',
      height: '3.5rem',
      color: $theme.colors.textHeading,
      fontWeight: 'bold',
    }),
  },
  ToggleIcon: {
    component: CustomToggleIcon,
  },
  Content: {
    style: {
      marginTop: 0,
      marginBottom: 0,
      marginLeft: 0,
      marginRight: 0,
      paddingTop: '0rem',
      paddingBottom: '1rem',
      paddingLeft: '1rem',
    },
  },
})

export const StyledPanelTitleContainer = styled('div', () => ({
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
  paddingLeft: '1rem',
}))

export const StyledPanelLeft = styled(FlexCenterY, {})

export const StyledPanelTitleText = styled('span', {
  marginLeft: '0.5rem',
})

export const StyledPanelCredit = styled('span', ({ $theme, $sold }) => ({
  padding: '0.25rem 0.5rem',
  color: $sold ? $theme.colors.positive600 : $theme.colors.mono500,
}))

export const StyledPanelContentContainer = styled('div', () => ({
  padding: 0,
}))

export const ButtonOverrides = {
  BaseButton: {
    style: ({ $theme }) => ({
      marginTop: '0.5rem',
      backgroundColor: $theme.colors.white,
      color: $theme.colors.black,
      border: `0.1rem solid ${$theme.colors.warning400}`,
      ':hover': {
        backgroundColor: $theme.colors.warning450,
        color: $theme.colors.white,
      },
    }),
  },
}

export const StyledTopContainerEmpty = styled('div', () => ({
  padding: '1rem',
}))

export const StyledHeaderEmpty = styled('div', () => ({}))

export const StyledEmptyMessageContainer = styled(FlexCenterY, {
  padding: '0rem 0.5rem 1rem 1rem',
})

export const StyledEmptyIcon = styled('img', () => ({
  width: 'auto',
}))

export const StyledEmptyText = styled('span', ({ $theme }) => ({
  paddingTop: '0.45rem',
  color: $theme.colors.grey,
}))
